import { HomeSearchIcon } from './HomeSearchIcon';

/**
 * author: Michael Irigoyen
 * id 156F3CF1-D7CD-487B-AF83-4A7270413A62
 * name home-search
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-search.svg
 * tags
 * - Home Automation 
 */
export const HouseFindIcon = HomeSearchIcon;
export default HouseFindIcon